import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { Modal } from '@atlaskit/onboarding';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';
function header() {
  return null;
}

// eslint-disable-next-line @repo/internal/react/no-class-components
export default class ModalDialog extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onPrimaryAction", () => {
      this.props.fireClickEvent('primary');
    });
    _defineProperty(this, "onSecondaryAction", () => {
      this.props.fireClickEvent('secondary');
    });
  }
  getActionButton(action, text, onClick) {
    return {
      text: text,
      onClick: e => {
        if (action.type === buttonActionTypes.LINK && action.data) {
          window.open(action.data.url, action.data.target);
        }
        onClick(e);
      }
    };
  }
  getActions() {
    const {
      primaryAction,
      primaryText,
      secondaryAction,
      secondaryText
    } = this.props;
    const actions = [];
    if (primaryAction && primaryText) {
      actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
    }
    if (secondaryAction && secondaryText) {
      actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
    }
    return actions;
  }
  getAdditionalModalProps() {
    const props = {};
    const {
      imageSrc
    } = this.props;
    if (imageSrc) {
      props.image = imageSrc;
    } else {
      props.header = header;
    }
    return props;
  }
  render() {
    const {
      title,
      body
    } = this.props;
    return /*#__PURE__*/React.createElement(Modal, _extends({
      actions: this.getActions(),
      heading: title
    }, this.getAdditionalModalProps()), /*#__PURE__*/React.createElement(HtmlContent, {
      html: body
    }));
  }
}